import '../../plugins/jquery.scrollpane.min.js';

$('.top-info-body').jScrollPane();
